module.exports = __webpack_public_path__ + "static/media/bg_campanha_escola.bea2eb27.png";